const activeNavItemClass = 'left-nav-active'

export const addActiveState = (element) => {
  element.classList.add(activeNavItemClass)
}

export const removeActiveState = (listItems) => {
  Array.prototype.forEach.call(listItems, function (item) {
    if (item.classList.contains(activeNavItemClass)) {
      item.classList.remove(activeNavItemClass)
    }
  })
}
